<div class="app flex-row align-items-center">
  <div class="clearfix">
    <h1 class="float-left display-3 mr-4">403</h1>
    <h4 class="pt-3">Action illégale, une alerte a été remontée aux administrateurs.</h4>
    <p class="text-muted">Votre IP sera temporairement bannie.</p>
  </div>
</div>
